import {Deserializable} from "./deserializable.model";

export class JobTypeAffidavit {

public job_type_affidavit_type_id: number;
public job_type_affidavit_type_name:string;
public job_type_affidavit_type_description:string;
public is_active:string;
public job_type_document_type_id:number;
public job_type_court_id:number;
public job_type_location_id:number;
public job_type_id:number;


  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): JobTypeAffidavit {
    Object.assign(this, input);

    return this;
  }


}
